<mat-tab-group [(selectedIndex)]="selectedTabIndex" mat-stretch-tabs="false">
  <mat-tab label="Übersicht">
    <app-grammar-overview></app-grammar-overview>
  </mat-tab>
  <mat-tab label="Systematische Grammatik">
    @if (selectedTabIndex === 1) {
      <app-sys-grammar></app-sys-grammar>
    }
  </mat-tab>
  <mat-tab label="Funktionale Grammatik">
    @if (selectedTabIndex === 2) {
      <app-func-grammar></app-func-grammar>
    }
  </mat-tab>
</mat-tab-group>
